import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Get from "../services/Get";
import {
  Button,
  Card,
  Col,
  List,
  message,
  Row,
  Space,
  Tabs,
  Typography,
  DatePicker,
  Tag,
} from "antd";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";

const Transaction = () => {
  const [walletAll, setWalletAll] = useState([]);
  const [sentTransactions, setSentTransactions] = useState([]);
  const [recievedTransactions, setRecievedTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [walletPaginated, setWalletPaginated] = useState({
    data: [],
    total: 0,
  });
  const [selectedType, setSelectedType] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();

  const formatDate = (date) => {
    return new Date(date).toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const getTypeTag = (type) => {
    console.log(type);
    if (type == "add_money") return <Tag color="green">Cash</Tag>;
    return <Tag color="purple">Income</Tag>;
  };

  const fetchWalletData = (from = null, to = null, page = 1, type = null) => {
    setLoading(true);
    Get.Wallet(from, to, page, type)
      .then((res) => {
        if (res.error) {
          message.error(res.error);
        }
        if (res.data) {
          const data = res.data.data;
          const meta = res.data;

          setWalletPaginated(meta);
          setWalletAll(data);
        }
      })
      .catch((error) => {
        console.error(error);
        message.error("Something went wrong");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    const fromStr = fromDate?.format("YYYY-MM-DD") ?? null;
    const toStr = toDate?.format("YYYY-MM-DD") ?? null;
    fetchWalletData(fromStr, toStr, currentPage, selectedType);
  }, [fromDate, toDate, currentPage, selectedType]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const onChangeFrom = (date) => {
    setFromDate(date);
  };

  const onChangeTo = (date) => {
    setToDate(date);
  };

  const ListTransactions = ({ transactions }) => (
    <List
      header={<Typography.Title level={4}>Transactions</Typography.Title>}
      bordered
      loading={loading}
      dataSource={transactions}
      pagination={{
        current: currentPage,
        total: walletPaginated.total,
        pageSize: 10,
        onChange: handlePageChange,
        position: "bottom",
        align: "end",
      }}
      renderItem={(item) => (
        <List.Item className="transection_list"
          actions={[
            <Button
              type="primary"
              className="form-btn"
              onClick={() => navigate(`/user/reciept/${item.id}`)}
            >
              View Details
            </Button>,
          ]}
        >
          <List.Item.Meta
            avatar={
              item.status === "success" ? (
                <CheckCircleOutlined style={{ color: "#4CAF50" }} />
              ) : item.status === "pending" ? (
                <ExclamationCircleOutlined style={{ color: "#ffd500" }} />
              ) : item.status === "rejected" ? (
                <CloseCircleOutlined style={{ color: "red" }} />
              ) : (
                "null"
              )
            }
            title={
              item.bill_payment ? (
                `Paid for ${item.bill_payment?.operator?.bill_category.category_name}`
              ) : (
                <>
                  {item.description} {getTypeTag(item.transaction)}
                </>
              )
            }
            description={
              <>
                Transaction Id: <Typography.Text>{item.id}</Typography.Text>
                <br />
                Amount: <Typography.Text>₹{item.amount}</Typography.Text>
                <br />
                Date:{" "}
                <Typography.Text>{formatDate(item.created_at)}</Typography.Text>
              </>
            }
          />
        </List.Item>
      )}
    />
  );

  const tabs = [
    {
      key: "1",
      label: "All",
      children: <ListTransactions transactions={walletAll} />,
    },
    {
      key: "2",
      label: "Sent",
      children: <ListTransactions transactions={walletAll} />,
    },
    {
      key: "3",
      label: "Received",
      children: <ListTransactions transactions={walletAll} />,
    },
  ];

  const handleTabChange = (key) => {
    setCurrentPage(1);
    if (key === "1") setSelectedType(null);
    if (key === "2") setSelectedType("debit");
    if (key === "3") setSelectedType("credit");
  };

  return (
    <div className="layout-content">
      <Row justify="center" className="mb-4">
        <Col xs={24} md={20}>
          <Space
            direction="vertical"
            size="middle"
            style={{
              display: "flex",
            }}
          >
            <Row justify={"end"}>
              <Button
                type="primary"
                className="form-btn"
                onClick={() => navigate("/user/add-money")}
              >
                <PlusCircleOutlined /> Add Money
              </Button>
            </Row>

            <Card>
              <Row justify={"end"}>
                <DatePicker
                  onChange={onChangeFrom}
                  placeholder="From"
                  style={{ margin: "10px" }}
                />
                <DatePicker
                  onChange={onChangeTo}
                  placeholder="To"
                  style={{ margin: "10px" }}
                />
              </Row>

              <Tabs
                defaultActiveKey="1"
                onChange={handleTabChange}
                items={tabs}
                itemActiveColor="#a6cc43"
              />
            </Card>
          </Space>
        </Col>
      </Row>
    </div>
  );
};

export default Transaction;
